import { Text } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../../../../../../common/hooks/useBrandedTranslation"

const FilterZeroResults = () => {
  const { t } = useBrandedTranslation()

  return (
    <Text fontSize="sm" color="black" mx={{ base: "4", sm: "6", md: "2" }} py="2" pl="2">
      {t("search-filters-no-results")}
    </Text>
  )
}

export default FilterZeroResults
